import React, { useState } from "react";
import FileUploadModal from "./FileUploadModal";

const MobileFolderUploadButton = ({ folderId, onUploaded, renameLoading }) => {
  const [showUpload, setShowUpload] = useState(false);
  return (
    <>
      {/* Global loader for rename operation */}
      {renameLoading && (
        <div className="fixed inset-0 flex items-center justify-center z-[9999] backdrop-blur-sm bg-transparent">
          <div className="flex flex-col items-center justify-center w-32 h-32 rounded-full bg-white/80 shadow-2xl border-2 border-blue-100">
            <svg className="animate-spin h-10 w-10 text-blue-600 mb-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
            </svg>
            <div className="text-blue-700 font-semibold text-center">Renaming file...</div>
          </div>
        </div>
      )}
      <button
        className="w-full py-2 mb-2 bg-blue-600 text-white rounded-lg font-semibold shadow hover:bg-blue-700 transition text-base focus:outline-none focus:ring-2 focus:ring-blue-300 bg-[#0071bd]"
        onClick={() => setShowUpload(true)}
        style={{ position: 'sticky', top: 0, zIndex: 20 }}
      >
        Upload Files
      </button>
      {showUpload && (
        <FileUploadModal
          folderId={folderId}
          onClose={() => setShowUpload(false)}
          onUploaded={onUploaded}
        />
      )}
    </>
  );
};

export default MobileFolderUploadButton;
